import React from "react";
import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout
      testid="refund-policy-page"
      title="Refund & Exchange Policy"
      intro="At turahtidclothing.com, we strive for complete customer satisfaction. Orders placed on our platform are processed in Jamaican Dollars (JMD) or United States Dollars (USD)."
    >
      <LegalSection heading="Return Eligibility">
        Items must be requested for return or exchange within 14 days of receipt. Products must be unworn, unwashed, and in original packaging with tags intact.
      </LegalSection>
      <LegalSection heading="Exchanges">
        Exchanges are subject to item availability. Customers in Jamaica may coordinate exchanges directly through our customer service.
      </LegalSection>
      <LegalSection heading="Refund Process">
        Once returned items are inspected, approved refunds will be processed back to the original card used via Sagicor payment processing within 5–10 business days. Original shipping fees are non-refundable.
      </LegalSection>
      <LegalSection heading="Non-Returnable Items">
        Sale/clearance items, customized items, and intimate apparel.
      </LegalSection>
      <LegalSection heading="How to Initiate a Return">
        Contact support at talenteduniquerebel@gmail.com or call +1 (876) 353-9081 with your Order ID.
      </LegalSection>
    </LegalLayout>
  );
}
